import React from 'react';
import { CheckCircle2 } from 'lucide-react';
const modules = [{
  title: 'Senior Fitness Foundations™',
  description: 'The professional framework for safe and effective senior training.'
}, {
  title: 'Movement Library™',
  description: '250+ senior-friendly exercises for every fitness level.'
}, {
  title: 'Session Builder System™',
  description: 'Build structured classes in minutes using proven templates.'
}, {
  title: 'Ready-To-Use Sessions™',
  description: 'Complete classes ready to teach immediately.'
}, {
  title: 'Progression Programs™',
  description: 'Long-term training plans that keep participants improving.'
}, {
  title: 'Coaching & Retention System™',
  description: 'Increase motivation, engagement, and attendance.'
}];
export function ModulesSection() {
  return <section className="py-12 px-4 sm:px-6 bg-cream border-y-4 border-ivory" data-id="element-114">
      <div className="text-center mb-10" data-id="element-115">
        <h2 className="text-3xl sm:text-4xl font-heading font-bold text-petrol mb-3 leading-tight uppercase" data-id="element-116">
          THE SOLUTION YOU'VE BEEN LOOKING FOR
        </h2>
        <p className="text-lg sm:text-xl font-subheading font-bold text-sage mb-4" data-id="element-117">
          6 professional modules in 1 complete coaching system
        </p>
        <div className="inline-block bg-petrol text-white px-4 py-1.5 rounded mb-5 shadow-sm" data-id="element-118">
          <p className="font-body font-bold text-sm tracking-widest uppercase" data-id="element-119">
            FITNESS SENIOR READY™ 6-in-1 Box Set
          </p>
        </div>
        <div className="max-w-3xl mx-auto text-graphite text-base sm:text-lg leading-relaxed" data-id="element-120">
          <p className="mb-2 font-bold" data-id="element-121">
            FITNESS SENIOR READY™ is much more than a collection of exercises.
          </p>
          <p data-id="element-122">
            It is a complete professional operating system designed to help you
            deliver safer, more structured, and more effective senior fitness
            programs.
          </p>
        </div>
      </div>

      <div className="flex flex-col gap-4 max-w-3xl mx-auto" data-id="element-123">
        {modules.map((module, i) => <div key={i} className="bg-ivory border border-gold/30 rounded-lg p-5 flex gap-4 items-start sm:items-center shadow-sm hover:shadow-md transition-shadow" data-id="element-124">
            <div className="mt-0.5 sm:mt-0" data-id="element-125">
              <CheckCircle2 className="w-6 h-6 text-sage" data-id="element-126" />
            </div>
            <div data-id="element-127">
              <h3 className="text-base sm:text-lg font-bold text-petrol leading-tight mb-1" data-id="element-128">
                {module.title}
              </h3>
              <p className="text-graphite text-sm sm:text-base leading-relaxed" data-id="element-129">
                {module.description}
              </p>
            </div>
          </div>)}
      </div>
    </section>;
}